import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { initializeInsurance, fetchInsuranceList, fetchInsurance, fetchInsuranceHouse, fetchInsuranceSelectBox, updateExpanded } from '@Root/slices/myhouse/insurance'
import { RootState } from '@Root/slices'
import { MY_HOUSE_AUTH_TYPE } from '@Root/contants/myhouse'
import { InsuranceParam } from '@Root/slices/myhouse/insuranceRegister'

export default function useInsurance() {
  const dispatch = useDispatch()
  const reduxMain = useSelector((state: RootState) => state.main)
  const myhouse = useSelector((state: RootState) => state.myhouse)
  const insurance = useSelector((state: RootState) => state.insurance)
  const { authHouseNoMap } = myhouse
  const { currentHouseNo } = reduxMain

  const isAuthenticate = (): boolean => {
    const authTypeKey = authHouseNoMap[currentHouseNo]?.authType
    const authType = MY_HOUSE_AUTH_TYPE[authTypeKey as keyof typeof MY_HOUSE_AUTH_TYPE]
    return authType === MY_HOUSE_AUTH_TYPE.BOTH || authType === MY_HOUSE_AUTH_TYPE.OWNER || authType === MY_HOUSE_AUTH_TYPE.RESIDENT
  }

  const setInsuranceExpanded = useCallback(
    (value: boolean) => {
      dispatch(updateExpanded(value))
    },
    [dispatch],
  )

  const loadInsuranceList = useCallback(
    (houseNo) => {
      dispatch(fetchInsuranceList(houseNo))
    },
    [dispatch],
  )

  const loadInsurance = useCallback(
    (param: InsuranceParam) => {
      dispatch(fetchInsurance(param))
    },
    [dispatch],
  )

  const loadInsuranceHouse = useCallback(
    (houseNo: number) => {
      dispatch(fetchInsuranceHouse(houseNo))
    },
    [dispatch],
  )

  const loadInsuranceSelectBox = useCallback(() => {
    dispatch(fetchInsuranceSelectBox())
  }, [dispatch])

  const insuranceInitialState = useCallback(() => {
    dispatch(initializeInsurance())
  }, [dispatch])

  return {
    insurance,
    isAuthenticate,
    loadInsuranceList,
    setInsuranceExpanded,
    loadInsurance,
    loadInsuranceHouse,
    loadInsuranceSelectBox,
    insuranceInitialState,
  }
}
